import { ReactComponent as CloseIcon } from '../../../assets/images/closeIcon.svg';
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { ReactComponent as AlertIcon } from '../../../assets/images/alert-circle.svg';
import { useMediaQuery } from "@mui/material";
export var JciReturnDisCard = function (_ref) {
    var onClose = _ref.onClose;
    // const { openPopper, handleClose, onDiscardButtonClick } = props;
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var formData = [{
            type: FormItemTypes.IconButton,
            name: 'icon',
            label: '',
            value: null,
            children: /*#__PURE__*/ React.createElement(AlertIcon, {
                color: "#FFAB00"
            }),
            columnSize: true,
            sx: {
                bgcolor: '#FFEECC',
                p: 1.5,
                height: '48px',
                width: '48px'
            }
        }, {
            type: FormItemTypes.IconButton,
            name: 'close',
            label: '',
            value: null,
            children: /*#__PURE__*/ React.createElement(CloseIcon, {
                fontSize: "small",
                color: "secondary"
            }),
            onClick: function () {
                onClose();
            },
            columnSize: 0
        }, {
            type: FormItemTypes.Typography,
            name: 'Msg',
            label: 'Want to discard this ?',
            value: null,
            columnSize: 12,
            children: "Are you sure you want to discard this ?",
            labelTypographyProps: {
                fontSize: "xl",
                fontWeight: "strong",
                color: "text.primary"
            },
            // variant: "h6",
            color: "secondary.600",
            fontSize: 'base',
            fontWeight: 'normal'
        },
        // {
        //     type: FormItemTypes.Button,
        //     name: 'cancel',
        //     label: '',
        //     value: null,
        //     children: 'Cancel',
        //     columnSize: 6,
        //     fullWidth: true,
        //     variant: 'outlined',
        //     size: 'small',
        //     sx: {
        //         py: 0.5, color: "#6A7682",
        //         border: '1px solid #DEE4EB',
        //         fontWeight: "medium",
        //         fontSize: "base"
        //     },
        //     onClick: handleClose
        // },
        // {
        //     type: FormItemTypes.Button,
        //     name: 'discard',
        //     label: '',
        //     value: null,
        //     children: 'Discard',
        //     columnSize: 6,
        //     fullWidth: true,
        //     // variant: 'contained',
        //     size: 'small',
        //     sx: {
        //         py: 0.5, color: "primary.contrastText",
        //         backgroundColor: "#F5222D",
        //         fontWeight: "medium",
        //         fontSize: "base"
        //     },
        //     onClick: onDiscardButtonClick
        // },
        {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            gap: 1.5,
            flexDirection: isMobile ? 'column' : 'row',
            spacing: 0,
            sx: {
                paddingTop: '32px',
                mt: 2
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'No',
                    columnSize: true,
                    fullWidth: true,
                    variant: 'outlined',
                    size: 'medium',
                    onClick: function () {
                        onClose();
                    },
                    color: 'secondary',
                    sx: {
                        fontSize: 'base',
                        fontWeight: 'medium',
                        p: '10px 14px'
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Yes, discard',
                    onClick: function () {
                        onClose();
                    },
                    color: 'error',
                    columnSize: true,
                    fullWidth: true,
                    variant: 'contained',
                    sx: {
                        fontSize: 'base',
                        fontWeight: 'medium',
                        p: '10px 14px'
                    }
                }]
        }];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridProps: {
            p: 2,
            gap: 2,
            spacing: 0
        }
    });
};
